<template>
  <Form :label-width="80"><Row>
    <i-col :xxl="4" :md="6" :sm="12">
      姓名：{{patientData.name}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      性别：{{patientData.sex === '0'?'男':patientData.sex === '1'?'女':'-'}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      年龄：{{patientData.age}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      联系电话：{{patientData.connectPhone}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      身高： {{patientData.height}}cm
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      体重： {{patientData.weight}}kg
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      出生日期：{{patientData.birthday ? moment(user.birthday).format('YYYY-MM-DD ') : ''}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      监护人：{{patientData.guardianName}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      备用联系：{{patientData.connectPhone}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      邮箱：{{patientData.email}}
    </i-col>
    <i-col :xxl="4" :md="6" :sm="12">
      住址：{{patientData.address}}
    </i-col>
  </Row>
  </Form>
</template>

<script>
  import Moment from 'moment'
  export default {
    name: "patient-info-module",
    components: {
      Moment,
    },
    props: {
      patientData: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        moment: Moment,
        connectTitle:[
          {
            type: 'index',
            width: 50,
            align: 'center',
          },
          {
            title: '联系人姓名',
            key: 'name',
            align: 'center',
          },
          {
            title: '联系人号码',
            key: 'phone',
            align: 'center',
          },
          {
            title: '联系人地址',
            key: 'address',
            align: 'center'
          }
        ],
      }
    },
  }
</script>

<style scoped>

</style>
